import { render } from "./FormGeneral.vue?vue&type=template&id=6eee9836"
import script from "./FormGeneral.vue?vue&type=script&lang=js"
export * from "./FormGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__